import { render, staticRenderFns } from "./piaoyouxiazuoshang.vue?vue&type=template&id=106ffee9&scoped=true&"
import script from "./piaoyouxiazuoshang.vue?vue&type=script&lang=js&"
export * from "./piaoyouxiazuoshang.vue?vue&type=script&lang=js&"
import style0 from "./piaoyouxiazuoshang.vue?vue&type=style&index=0&id=106ffee9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ffee9",
  null
  
)

export default component.exports